import React, { Fragment, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import PropTypes from 'prop-types';

const Formulario = ({crearCita}) => {

    const [cita, datosCita] = useState({
        mascota: '',
        propietario: '',
        fecha: '',
        hora: '',
        razon:''
    });

    const [ error, actualizarError] = useState(false);

    const handleChange = e => {
        datosCita({
            ...cita,
            [e.target.name] : e.target.value
        })
    }
        //Validar el form
    const submitCita = (e) => {
        e.preventDefault();

        if(mascota.trim() === '' || propietario.trim() === '' || fecha.trim() === '' || hora.trim() === '' || razon.trim() === '' ){
            actualizarError(true);
            return;
        }

        //Eliminar el mensaje de error
        actualizarError(false);

        //Asignar un id
        cita.id= uuidv4();

        //Crear la cita
        crearCita(cita);
        //Reiniciar el form
        datosCita({
            mascota: '',
            propietario: '',
            fecha: '',
            hora: '',
            razon:''
        })
    }

    const {mascota, propietario, fecha, hora, razon} = cita;

    return ( 
    <Fragment>
        <h2>Agenda tu cita</h2>
        {error ? <p className="alerta-error">Todos los campos deben ser llenados</p> :null}

        <form
            onSubmit={submitCita}
        >
            
            <label>Nombre de tu mascota</label>
            <input 
                type="text"
                name="mascota"
                className="u-full-width"
                placeholder="Nombre Mascota"
                onChange={handleChange}
                value= {mascota}
            />
            
             <label>Nombre del dueño</label>
            <input 
                type="text"
                name="propietario"
                className="u-full-width"
                placeholder="Nombre dueño de la mascota"
                onChange={handleChange}
                value= {propietario}
            />

             <label>Fecha de la cita</label>
            <input 
                type="date"
                name="fecha"
                className="u-full-width"
                onChange={handleChange}
                value= {fecha}
            />
            
             <label>Hora de la cita</label>
            <input 
                type="time"
                min="08:00:00"
                max="18:00:00"
                step="600"
                name="hora"
                className="u-full-width"
                onChange={handleChange}
                value= {hora}
            />

             <label>Raz&oacute;n de consulta</label>
            <textarea
                name="razon"
                className="u-full-width"
                placeholder="Salud... Cuidados... Conducta... Vacunas... Todo lo anterior"
                onChange={handleChange}
                value= {razon}
            ></textarea>

            <button
                type="submit"
                className="u-full-width button-primary"
            >Agendar cita
            </button>
        </form>
    </Fragment>
            );
}

Formulario.propTypes = {
    crearCita: PropTypes.func.isRequired
}
 
export default Formulario;

